/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class claimsupplementalinformation extends IceEntity {
  claim_supplemental_information_key: string = "";
  encounter_key: string = "";
  diagnosis_key: string = "";
  encounter_progress_notes_key: string = "";
  external_data_key: string = "";
  observation_key: string = "";
  report_type_code: string = "";
  report_transmission_code: string = "";
  identification_code_qualifier: string = "";
  identification_code: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
    return "CLAIM_SUPPLEMENTAL_INFORMATION";
  }
}
